import { Component } from 'react';

class SeizureActivityDocumentation extends Component {
  render() {
    return <h1>Seizure Activity Documentation</h1>;
  }
}

export default SeizureActivityDocumentation;
